import { Typography } from 'antd';
import { formatTime } from '../../utils/formatTime';
import {ClockCircleOutlined} from "@ant-design/icons";
import React from "react";

const { Text } = Typography;

export default function RecordingTimerSection({ elapsedTime }) {
  return (
    <div style={{ textAlign: 'center', marginBottom: 30, marginTop: 30 }}>
      <Text style={{ fontSize: elapsedTime < 5 ? 14 : 20, fontFamily: 'monospace' }}>
        {formatTime(elapsedTime)}
      </Text>
    </div>
  );
}